const T_PREFIX = "user-profile";

export const rolesTrns = {
  agent: `${T_PREFIX}.roles.agent`,
  owner: `${T_PREFIX}.roles.owner`,
  seller: `${T_PREFIX}.roles.common`,
};

export const tabsTrns = {
  profile: `${T_PREFIX}.tabs.profile`,
  clones: `${T_PREFIX}.tabs.clones`,
  inquiries: `${T_PREFIX}.tabs.inquiries`,
};

export const profileCardTrns = {
  buys: `${T_PREFIX}.profile-card.metrics.buys`,
  sales: `${T_PREFIX}.profile-card.metrics.sales`,
  clones: `${T_PREFIX}.profile-card.metrics.clones`,
};

export const noProfileBannerTrns = {
  clonesTitle: `${T_PREFIX}.no-profile-banner.clones-title`,
  inquiriesTitle: `${T_PREFIX}.no-profile-banner.inquiries-title`,
};

export const metaTrns = {
  title: `${T_PREFIX}.meta.title`,
  description: `${T_PREFIX}.meta.description`,
};
